import type { SupportedAlpha3CountryCode } from '@/lib/utils/localization/getSupportedAlpha3CountryCodes'
import { toAlpha2 } from '@/lib/utils/localization/toAlpha2'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import useGlobalStore from '@/store/useGlobalStore'
import { useSetCookie } from 'cookies-next/client'
import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

export const useMixpanelProperties = () => {
  const setCookie = useSetCookie()
  const {
    app: { alpha2 },
    user: { isSignedIn, customerType },
  } = useGlobalStore()
  const router = useRouter()
  const hasTracked = useRef(false)

  useEffect(() => {
    if (!router.isReady || hasTracked.current) {
      return
    }

    const queryAlpha2 = router.query.alpha3
      ? toAlpha2(router.query.alpha3 as SupportedAlpha3CountryCode)
      : alpha2

    if (alpha2 !== queryAlpha2) {
      setCookie('country', queryAlpha2)
    } else {
      setCookie('country', alpha2)
    }

    if (router.query.language) {
      setCookie('language', router.query.language)
    }

    hasTracked.current = true

    mixpanelService.initializeSuperProperties()
    mixpanelService.trackPageView()
  }, [router.isReady, router.query, alpha2])

  useEffect(() => {
    setCookie('is_user_logged_in', isSignedIn)
    mixpanelService.registerSuperProperties({
      is_user_logged_in: isSignedIn ? 'true' : 'false',
    })
  }, [isSignedIn])

  useEffect(() => {
    if (isSignedIn) {
      setCookie('user_type', customerType)
    }
  }, [isSignedIn, customerType])
}
